import { render, staticRenderFns } from "./ClassEdit.vue?vue&type=template&id=de3ec7e2"
import script from "../../controllers/class/class-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/class/class-edit.js?vue&type=script&lang=js&external"
import style0 from "./ClassEdit.vue?vue&type=style&index=0&id=de3ec7e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports